import React from 'react';
// import { Image } from 'react-bootstrap';
import { connect } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import MembershipInfoCard from '../../../components/customer/MembershipInfoCard';
import { getImageUrl } from '../../../utils';
import i18n from '../../../I18n';
import '../../campaign/campaignCreation/CreateCampaignStepFour.scss';
import { LanguageConfig } from '../../../config/CustomEnums';
import ContentSections from '../../base/ContentSections';
import stampCampaignPreview from '../../../assets/images/campaign/preview_stamp_campaigns.svg';
import ContentLanguageCard from 'components/campaign/campaignCreation/ContentLanguageCard';

// const fieldsLanguages = [
//   LanguageConfig.english,
//   LanguageConfig.traditionalChinese,
//   LanguageConfig.simplifiedChinese,
// ];

// const detailPhotos = [
//   'detailPhotoOne',
//   'detailPhotoTwo',
//   'detailPhotoThree',
//   'detailPhotoFour',
// ];

function ContentSection({ languages, data }) {
  const { getValues } = useFormContext() || {};
  const campaign = data || getValues() || {};
  const translations = campaign.translations || {};

  // const getDetailPhotosWithOneLanguage = (language) => {
  //   const mapResult = detailPhotos.map((detailPhoto) =>
  //     translations[language][detailPhoto] ? (
  //       <Image
  //         key={`detail-photo-${language}-${translations[language][detailPhoto]}`}
  //         className="content-section-rectangle-image content-section-detail-photo"
  //         src={translations[language][detailPhoto]}
  //       />
  //     ) : null,
  //   );
  //   const deleteNullItem = mapResult.filter((result) => result);
  //   return deleteNullItem.length === 0 ? '-' : deleteNullItem;
  // };

  // const images = () => {
  //   return (
  //     <>
  //       {fieldsLanguages.map((language, index) => (
  //         <td key={`fieldsLanguages-${language}-${index}`}>
  //           <div className="content-section-detail-photo-container">
  //             {getDetailPhotosWithOneLanguage(language)}
  //           </div>
  //         </td>
  //       ))}
  //     </>
  //   );
  // };

  const renderTabForLanguage = (language) => {
    return (
      <ContentLanguageCard
        campaignData={campaign}
        language={language}
      />
    )
  };

  return (
    <ContentSections
      hidePreview
      languageTabContent={{
        containers: languages?.map((item) => ({
          container: [renderTabForLanguage(item.code)],
          key: item.code,
          title: item.sourceName || item.name,
        })),
      }}
      activeSection={LanguageConfig.english}
      contentStyle="campaign-detail-language-content-sections"
      inputWithImageConfig={{}}
      defaultImage={stampCampaignPreview}
    />
  );
}

const mapPropsToState = (state) => ({
  languages: state.language.allList,
});

export default connect(mapPropsToState)(ContentSection);
